import React, { FC } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import InfoTooltip from '../../../infoToolTip';
import { TMsrpBlockProps } from '../../types/seriesListing.types';

const MsrpBlock: FC<WithTranslation & TMsrpBlockProps> = (props) => {
  const { msrp, t } = props;
  const msrpTooltipTitle = t('cnhi-MsrpTooltipTitle');
  const msrpTooltipDescription = t('cnhi-MsrpTooltipDescription');
  if (!msrp) return null;
  return (
    <>
      <RichText
        field={{ value: `${t('cnhi-startingFrom')} ${msrp}` }}
        tag="div"
        className="product-card__description rich-text"
        editable={false}
      />
      <InfoTooltip showIcon={true} width={392} className="product-card__content-tooltip" clickPreventDefault={true}>
        <div className="product-card__content-tooltip--wrapper">
          <Text field={{ value: msrpTooltipTitle }} tag="h2" className="product-card__content-tooltip--title" editable={false} />
          <Text field={{ value: msrpTooltipDescription }} tag="div" className="product-card__content-tooltip--body" editable={false} />
        </div>
      </InfoTooltip>
    </>
  );
};

export default withTranslation()(MsrpBlock);
